<div class="w-full flex flex-row items-center">
  @if (icon) {
    <svg-icon
      class="pr-0 h-4 w-4 mr-2"
      placement="top"
      preserveAspectRatio="none"
      [src]="icon"
      [stretch]="true"
      [ngbTooltip]="iconTooltip"
      [keepOnHover]="true"
      [tooltipClass]="'default-tooltip z-50'"
    ></svg-icon>
  }

  <span
    class="metadata-value flex-1 text-navy-90 overflow-hidden overflow-ellipsis"
    [class.font-bold]="boldValue"
    [ngbTooltip]="metadataView"
    [placement]="overflowTooltipPlacement ?? 'top'"
    [openTooltipWhenOverflowedAndHovered]="true"
    [openOnWidthOverflow]="true"
  >
    <ng-container *ngTemplateOutlet="metadataView"></ng-container>
  </span>

  @if (infoIconTooltip) {
    <svg-icon
      class="w-3.5 ml-1"
      [src]="'info-dark'"
      [ngbTooltip]="infoIconTooltip"
      [keepOnHover]="true"
    ></svg-icon>
  }
</div>

<ng-template #metadataView>
  {{ metadataValue }}
</ng-template>

@if (metadataDescriptionTranslationKey) {
  <span class="metadata-description w-full {{ darkText ? 'text-navy-70 text-sm' : 'text-navy-50' }} overflow-hidden overflow-ellipsis">
    {{ metadataDescriptionTranslationKey | translate }}
  </span>
}
